export const RefreshBtn = ({onClick, label}) => {
    return <button type='button' onClick={() => {onClick()}} className='btn btn-primary' style={{width: '150px'}}>
        {label}
    </button>
}